import { render, staticRenderFns } from "./FlagPermission.vue?vue&type=template&id=37a3f563&scoped=true&"
import script from "./FlagPermission.vue?vue&type=script&lang=js&"
export * from "./FlagPermission.vue?vue&type=script&lang=js&"
import style0 from "./FlagPermission.vue?vue&type=style&index=0&id=37a3f563&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a3f563",
  null
  
)

export default component.exports